import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class StorageService {
  static key = '7061737323313233';
  public static getPerfilUsuario(): any {
    const salt = btoa('sequoia');

    if (localStorage.getItem('dGlwbw==') === null
      && localStorage.getItem('ZGVzY3JpY2Fv') === null
      && localStorage.getItem('ZmlsaWFsaWQ=') === null
      && localStorage.getItem('bm9tZQ==') === null
      && localStorage.getItem('ZW1haWw=') === null
      && localStorage.getItem('dXNlcm5hbWU=') === null
      && localStorage.getItem('cGVyZmlsYWNlc3NvaWQ=') === null
      && localStorage.getItem('ZnVuY2lvbmFsaWRhZGVzYWp1ZGE=') === null
    ) {
      return null;
    }

    const perfilacessotipo = +atob(localStorage.getItem('dGlwbw==')?.replace(salt, ''));
    const descricao = atob(localStorage.getItem('ZGVzY3JpY2Fv')?.replace(salt, ''));
    const filialid = +atob(localStorage.getItem('ZmlsaWFsaWQ=')?.replace(salt, ''));
    const nome = atob(localStorage.getItem('bm9tZQ==')?.replace(salt, ''));
    const email = atob(localStorage.getItem('ZW1haWw=')?.replace(salt, ''));
    const agenteid = +atob(localStorage.getItem('YWdlbnRlaWQ=')?.replace(salt, ''));
    const codIata = atob(localStorage.getItem('Y29kSWF0YQ==')?.replace(salt, ''));

    const username = localStorage.getItem('dXNlcm5hbWU=')
      ? atob(localStorage.getItem('dXNlcm5hbWU=')?.replace(salt, ''))
      : '';
    const auth_token = atob(localStorage.getItem('YXV0aF90b2tlbg==')?.replace(salt, ''));
    const funcionalidade_ajuda = localStorage.getItem('ZnVuY2lvbmFsaWRhZGVzYWp1ZGE=')
      ? atob(localStorage.getItem('ZnVuY2lvbmFsaWRhZGVzYWp1ZGE=')?.replace(salt, ''))
      : '';

    return { perfilacessotipo, descricao, filialid, nome, email, agenteid, codIata, username, auth_token, funcionalidade_ajuda };
  }

public static getExternalAccess(){
  let data = localStorage.getItem('externalAccess');
  return data ? JSON.parse(data) : null;
}
public static setExternalAccess(obj){
  const parsed = JSON.stringify(obj);
  localStorage.setItem('externalAccess', parsed);
}
  public static getToken(): string {
    var user = this.getPerfilUsuario();
    if (user != null)
      return user.auth_token;

    user = this.getExternalAccess();
    if (user != null)
      return user.token;

    return null;
  }

  public static setItemLocalStorage(key: string, value: string) {
    localStorage.setItem(key, value);
  }

  public static getItemLocalStorage(key: string) {
    return localStorage.getItem(key);
  }
}
